import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/home";

export default function HeroCarousel() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => (prev + 1) % heroSlides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const go = (index: number) => setActive((index + heroSlides.length) % heroSlides.length);

  return (
    <section className="page-wrap pt-6" aria-label="焦点轮播">
      <div className="relative h-[380px] w-full overflow-hidden rounded-lg bg-secondary-900 md:h-[480px]">
        {heroSlides.map((slide, index) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              index === active ? "opacity-100" : "pointer-events-none opacity-0"
            }`}
          >
            <img
              src={slide.image}
              alt={slide.title}
              title={`${slide.title} - 漫蛙2`}
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-secondary-950/85 via-secondary-950/55 to-transparent" />
            <div className="absolute inset-0 flex items-center">
              <div className="w-full px-6 md:px-12 lg:px-16">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                  <i className="ri-fire-line"></i>
                  {slide.tag}
                </span>
                <h2 className="mt-4 max-w-xl text-2xl font-extrabold leading-tight text-background-50 md:text-4xl">
                  {slide.title}
                </h2>
                <p className="mt-3 max-w-lg text-sm leading-relaxed text-background-200 md:text-base">
                  {slide.subtitle}
                </p>
                <Link
                  to={slide.link}
                  className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  查看详情
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        ))}

        <button
          type="button"
          onClick={() => go(active - 1)}
          aria-label="上一张"
          className="absolute left-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-secondary-950/40 text-background-50 backdrop-blur transition-colors hover:bg-secondary-950/70 md:left-5 md:h-10 md:w-10"
        >
          <i className="ri-arrow-left-s-line text-xl"></i>
        </button>
        <button
          type="button"
          onClick={() => go(active + 1)}
          aria-label="下一张"
          className="absolute right-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-secondary-950/40 text-background-50 backdrop-blur transition-colors hover:bg-secondary-950/70 md:right-5 md:h-10 md:w-10"
        >
          <i className="ri-arrow-right-s-line text-xl"></i>
        </button>

        <div className="absolute bottom-4 left-1/2 flex -translate-x-1/2 items-center gap-2">
          {heroSlides.map((slide, index) => (
            <button
              key={slide.id}
              type="button"
              aria-label={`切换到第 ${index + 1} 张`}
              onClick={() => go(index)}
              className={`h-2 rounded-full transition-all ${
                index === active ? "w-6 bg-primary-500" : "w-2 bg-background-200/70"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}